/**
 * Materialize Stepper - A little plugin that implements a stepper to Materializecss framework.
 * @version v3.0.0-beta.1.1.1
 * @author Igor Marcossi (Kinark) <igormarcossi@gmail.com>.
 * @link https://github.com/Kinark/Materialize-stepper
 *
 * Licensed under the MIT License (https://github.com/Kinark/Materialize-stepper/blob/master/LICENSE).
 */

function _classCallCheck(e, t) {
    if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
    for (var n = 0; n < t.length; n++) {
        var i = t[n];
        (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
    }
}

function _createClass(e, t, n) {
    return (
        t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e
    );
}

function _defineProperty(e, t, n) {
    return (
        t in e
            ? Object.defineProperty(e, t, {
                  value: n,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
              })
            : (e[t] = n),
        e
    );
}
var MStepper = (function () {
    function E(e) {
        var P = this,
            t =
                1 < arguments.length && void 0 !== arguments[1]
                    ? arguments[1]
                    : {};
        _classCallCheck(this, E),
            _defineProperty(this, "_init", function () {
                var e = P._formWrapperManager,
                    t = P.getSteps,
                    n = P.options,
                    i = P.stepper,
                    r = P.classes,
                    s = P._methodsBindingManager,
                    o = P._openAction;
                (P.form = e()),
                    o(t().steps[n.firstActive], void 0, void 0, !0),
                    s(i.querySelectorAll(".".concat(r.STEP)));
            }),
            _defineProperty(this, "_methodsBindingManager", function (e) {
                var t =
                        1 < arguments.length &&
                        void 0 !== arguments[1] &&
                        arguments[1],
                    o = P.classes,
                    a = P._formSubmitHandler,
                    l = P._nextStepProxy,
                    c = P._prevStepProxy,
                    p = P._stepTitleClickHandler,
                    d = P.form,
                    v = P.options,
                    n = E.nodesIterator,
                    f = E.tabbingDisabler,
                    u = t
                        ? E.removeMultipleEventListeners
                        : E.addMultipleEventListeners,
                    i = function i(e) {
                        var t = e.getElementsByClassName(o.NEXTSTEPBTN),
                            n = e.getElementsByClassName(o.PREVSTEPBTN),
                            i = e.getElementsByClassName(o.STEPTITLE),
                            r = e.querySelectorAll(
                                "input, select, textarea, button"
                            ),
                            s = e.querySelectorAll('button[type="submit"]');
                        return (
                            u(t, "click", l, !1),
                            u(n, "click", c, !1),
                            u(i, "click", p),
                            r.length && u(r[r.length - 1], "keydown", f),
                            s &&
                                d &&
                                v.validationFunction &&
                                u(s, "keydown", a),
                            e
                        );
                    };
                e instanceof Element
                    ? i(e)
                    : n(e, function (e) {
                          return i(e);
                      });
            }),
            _defineProperty(this, "_formSubmitHandler", function (e) {
                P._validationFunctionCaller() || e.preventDefault();
            }),
            _defineProperty(this, "resetStepper", function () {
                P.form && (P.form.reset(), P.openStep(P.options.firstActive));
            }),
            _defineProperty(this, "_openAction", function (e, t) {
                var n =
                        !(2 < arguments.length && void 0 !== arguments[2]) ||
                        arguments[2],
                    i = 3 < arguments.length ? arguments[3] : void 0,
                    r = P._slideDown,
                    s = P.classes,
                    o = P.getSteps,
                    a = P._closeAction,
                    l = P.stepper,
                    c = P.options,
                    p = o().active.step;
                if (p && p.isSameNode(e)) return e;
                var d = e.getElementsByClassName(s.STEPCONTENT)[0];
                return (
                    e.classList.remove(s.DONESTEP),
                    window.innerWidth < 993 ||
                    !l.classList.contains(s.HORIZONTALSTEPPER)
                        ? (r(d, s.ACTIVESTEP, e, t),
                          i ||
                              r(d, s.ACTIVESTEP, e, function () {
                                  var e = d.querySelector(
                                      "input, select, textarea"
                                  );
                                  c.autoFocusInput && e && e.focus(),
                                      t && "function" == typeof t && t();
                              }))
                        : e.classList.add("active"),
                    p && n && a(p),
                    e
                );
            }),
            _defineProperty(this, "_closeAction", function (e, n) {
                var t = P._slideUp,
                    i = P.classes,
                    r = P.stepper,
                    s = P._smartListenerUnbind,
                    o = P._smartListenerBind,
                    a = e.getElementsByClassName(i.STEPCONTENT)[0];
                if (
                    window.innerWidth < 993 ||
                    !r.classList.contains(i.HORIZONTALSTEPPER)
                )
                    t(a, i.ACTIVESTEP, e, n);
                else {
                    if (n) {
                        o(a, "transitionend", function e(t) {
                            "left" === t.propertyName &&
                                (s(a, "transitionend", e), n());
                        });
                    }
                    e.classList.remove("active");
                }
                return e;
            }),
            _defineProperty(this, "_nextStepProxy", function (e) {
                return P.nextStep(void 0, void 0, e);
            }),
            _defineProperty(this, "_prevStepProxy", function (e) {
                return P.prevStep(void 0, e);
            }),
            _defineProperty(this, "_stepTitleClickHandler", function (e) {
                var t = P.getSteps,
                    n = P.classes,
                    i = P.nextStep,
                    r = P.prevStep,
                    s = P.stepper,
                    o = P._openAction,
                    a = t(),
                    l = a.steps,
                    c = a.active,
                    p = e.target.closest(".".concat(n.STEP));
                if (s.classList.contains(n.LINEAR)) {
                    var d = Array.prototype.indexOf.call(l, p);
                    d == c.index + 1 ? i() : d == c.index - 1 && r();
                } else o(p);
            }),
            _defineProperty(this, "nextStep", function (e, t, n) {
                n && n.preventDefault && n.preventDefault();
                var i = P.options,
                    r = P.getSteps,
                    s = P.activateFeedback,
                    o = P.form,
                    a = P.wrongStep,
                    l = P.classes,
                    c = P._openAction,
                    p = P.stepper,
                    d = P.events,
                    v = P.destroyFeedback,
                    f = P._validationFunctionCaller,
                    u = i.showFeedbackPreloader,
                    E = i.validationFunction,
                    y = r().active,
                    h = r().steps[y.index + 1],
                    m = n && n.target ? n.target.dataset.feedback : null;
                return E && !f()
                    ? a()
                    : m && !t
                    ? (u && !y.step.dataset.nopreloader && s(),
                      void window[m](
                          v,
                          o,
                          y.step.querySelector(".".concat(l.STEPCONTENT))
                      ))
                    : (y.step.classList.add(l.DONESTEP),
                      c(h, e),
                      p.dispatchEvent(d.STEPCHANGE),
                      void p.dispatchEvent(d.NEXTSTEP));
            }),
            _defineProperty(this, "prevStep", function (e, t) {
                t && t.preventDefault && t.preventDefault();
                var n = P.getSteps,
                    i = P._openAction,
                    r = P.stepper,
                    s = P.events,
                    o = P.destroyFeedback,
                    a = n().active,
                    l = n().steps[a.index + -1];
                o(),
                    i(l, e),
                    r.dispatchEvent(s.STEPCHANGE),
                    r.dispatchEvent(s.PREVSTEP);
            }),
            _defineProperty(this, "openStep", function (e, t) {
                var n = P.getSteps,
                    i = P._openAction,
                    r = P.stepper,
                    s = P.events,
                    o = P.destroyFeedback,
                    a = n().steps[e];
                o(), i(a, t), r.dispatchEvent(s.STEPCHANGE);
            }),
            _defineProperty(this, "wrongStep", function () {
                var t = P.getSteps,
                    n = P.classes,
                    e = P.stepper,
                    i = P.events;
                t().active.step.classList.add(n.WRONGSTEP);
                var r = t().active.step.querySelectorAll(
                    "input, select, textarea"
                );
                E.addMultipleEventListeners(r, "input", function e() {
                    t().active.step.classList.remove(n.WRONGSTEP),
                        E.removeMultipleEventListeners(r, "input", e);
                }),
                    e.dispatchEvent(i.STEPERROR);
            }),
            _defineProperty(this, "activateFeedback", function () {
                var e = P.getSteps,
                    t = P.classes,
                    n = P.options,
                    i = P.stepper,
                    r = P.events,
                    s = e().active.step;
                s.classList.add(t.FEEDBACKINGSTEP),
                    s
                        .getElementsByClassName(t.STEPCONTENT)[0]
                        .insertAdjacentHTML(
                            "afterBegin",
                            '<div class="'
                                .concat(t.PRELOADERWRAPPER, '">')
                                .concat(n.feedbackPreloader, "</div>")
                        ),
                    i.dispatchEvent(r.FEEDBACKING);
            }),
            _defineProperty(this, "destroyFeedback", function (e) {
                var t = P.getSteps,
                    n = P.classes,
                    i = P.nextStep,
                    r = P.stepper,
                    s = P.events,
                    o = t().active.step;
                if (o && o.classList.contains(n.FEEDBACKINGSTEP)) {
                    o.classList.remove(n.FEEDBACKINGSTEP);
                    var a = o.getElementsByClassName(n.PRELOADERWRAPPER)[0];
                    a.parentNode.removeChild(a),
                        e && i(void 0, !0),
                        r.dispatchEvent(s.FEEDBACKDESTROYED);
                }
            }),
            _defineProperty(this, "getSteps", function () {
                var e = P.stepper,
                    t = P.classes,
                    n = e.querySelectorAll("li.".concat(t.STEP)),
                    i = e.querySelector("li.".concat(t.ACTIVESTEP));
                return {
                    steps: n,
                    active: {
                        step: i,
                        index: Array.prototype.indexOf.call(n, i),
                    },
                };
            }),
            _defineProperty(this, "activateStep", function (e, t) {
                var n = P.getSteps,
                    i = P._slideDown,
                    r = P.stepper,
                    s = P._methodsBindingManager,
                    o = E.nodesIterator,
                    a = n().steps[t],
                    l = null;
                return (
                    "string" == typeof e
                        ? (a.insertAdjacentHTML("beforeBegin", e),
                          (l = a.previousSibling),
                          i(l))
                        : Array.isArray(e)
                        ? ((l = []),
                          e.forEach(function (e) {
                              a.insertAdjacentHTML("beforeBegin", e),
                                  l.push(a.previousSibling),
                                  i(a.previousSibling);
                          }))
                        : (e instanceof Element ||
                              e instanceof HTMLCollection ||
                              e instanceof NodeList) &&
                          ((l = r.insertBefore(e, a)),
                          e instanceof Element
                              ? i(l)
                              : o(l, function (e) {
                                    return i(e);
                                })),
                    l && s(l),
                    l
                );
            }),
            _defineProperty(this, "deactivateStep", function (t) {
                var n = P._slideUp,
                    i = P.stepper,
                    r = P._methodsBindingManager,
                    e = E.nodesIterator,
                    s = function s(e) {
                        i.contains(t) &&
                            (r(e, !0),
                            n(e, void 0, void 0, function () {
                                return i.removeChild(e);
                            }));
                    };
                return (
                    t instanceof Element
                        ? s(t)
                        : (t instanceof HTMLCollection ||
                              t instanceof NodeList) &&
                          e(t, function (e) {
                              return s(e);
                          }),
                    t
                );
            }),
            _defineProperty(this, "_slideDown", function (n, e) {
                var t =
                        2 < arguments.length && void 0 !== arguments[2]
                            ? arguments[2]
                            : n,
                    i = 3 < arguments.length ? arguments[3] : void 0,
                    r = "".concat(E.getUnknownHeight(n), "px"),
                    s = function e(t) {
                        "height" === t.propertyName &&
                            (P._smartListenerUnbind(n, "transitionend", e),
                            E.removeMultipleProperties(
                                n,
                                "visibility overflow height display"
                            ),
                            i && i());
                    };
                return (
                    requestAnimationFrame(function () {
                        (n.style.overflow = "visible"),
                            (n.style.paddingBottom = "0"),
                            (n.style.height = "0"),
                            (n.style.visibility = "unset"),
                            (n.style.display = "block"),
                            requestAnimationFrame(function () {
                                P._smartListenerBind(n, "transitionend", s),
                                    (n.style.height = r),
                                    n.style.removeProperty("padding-bottom"),
                                    e && t.classList.add(e);
                            });
                    }),
                    n
                );
            }),
            _defineProperty(this, "_slideUp", function (n, e) {
                var t =
                        2 < arguments.length && void 0 !== arguments[2]
                            ? arguments[2]
                            : n,
                    i = 3 < arguments.length ? arguments[3] : void 0,
                    r = "".concat(n.offsetHeight, "px"),
                    s = function e(t) {
                        "height" === t.propertyName &&
                            (P._smartListenerUnbind(n, "transitionend", e),
                            (n.style.display = "none"),
                            E.removeMultipleProperties(
                                n,
                                "visibility overflow height padding-bottom"
                            ),
                            i && i());
                    };
                return (
                    requestAnimationFrame(function () {
                        (n.style.overflow = "visible"),
                            (n.style.visibility = "unset"),
                            (n.style.display = "block"),
                            (n.style.height = r),
                            requestAnimationFrame(function () {
                                P._smartListenerBind(n, "transitionend", s),
                                    (n.style.height = "0"),
                                    (n.style.paddingBottom = "0"),
                                    e && t.classList.remove(e);
                            });
                    }),
                    n
                );
            }),
            _defineProperty(this, "_formWrapperManager", function () {
                var e = P.stepper,
                    t = P.options,
                    n = e.closest("form");
                if (n || !t.autoFormCreation) return n.length ? n : null;
                var i = e.dataset || {},
                    r = i.method || "GET",
                    s = i.action || "?",
                    o = document.createElement("form");
                return (
                    (o.method = r),
                    (o.action = s),
                    e.parentNode.insertBefore(o, e),
                    o.appendChild(e),
                    o
                );
            }),
            _defineProperty(this, "_validationFunctionCaller", function () {
                var e = P.options,
                    t = P.getSteps,
                    n = P.form,
                    i = P.classes;
                return e.validationFunction(
                    n,
                    t().active.step.querySelector(".".concat(i.STEPCONTENT))
                );
            }),
            _defineProperty(this, "_smartListenerBind", function (e, t, n) {
                var i =
                        !(3 < arguments.length && void 0 !== arguments[3]) ||
                        arguments[3],
                    r =
                        4 < arguments.length &&
                        void 0 !== arguments[4] &&
                        arguments[4],
                    s = P.listenerStore,
                    o = {
                        el: e,
                        event: t,
                        fn: n,
                    };
                if (i)
                    for (var a = 0; a < s.length; a++) {
                        var l = s[a];
                        l.event === t &&
                            l.el.isSameNode(e) &&
                            l.el.removeEventListener(l.event, l.fn),
                            r && l.fn();
                    }
                else {
                    var c = s.indexOf(o);
                    if (-1 !== p) {
                        var p = s[c];
                        p.el.removeEventListener(p.event, p.fn), r && p[c].fn();
                    }
                }
                e.addEventListener(t, n), s.push(o);
            }),
            _defineProperty(this, "_smartListenerUnbind", function (e, t, n) {
                var i = P.listenerStore,
                    r = i.indexOf({
                        el: e,
                        event: t,
                        fn: n,
                    });
                e.removeEventListener(t, n), i.splice(r, 1);
            }),
            (this.stepper = e),
            (this.options = {
                firstActive: t.firstActive || 0,
                linearStepsNavigation: t.linearStepsNavigation || !0,
                autoFocusInput: t.autoFocusInput || !0,
                showFeedbackPreloader: t.showFeedbackPreloader || !0,
                autoFormCreation: t.autoFormCreation || !0,
                validationFunction: t.validationFunction || null,
                feedbackPreloader:
                    t.feedbackPreloader ||
                    '<div class="preloader-wrapper active"> <div class="spinner-layer spinner-blue-only"> <div class="circle-clipper left"> <div class="circle"></div></div><div class="gap-patch"> <div class="circle"></div></div><div class="circle-clipper right"> <div class="circle"></div></div></div></div>',
            }),
            (this.classes = {
                HORIZONTALSTEPPER: "horizontal",
                LINEAR: "linear",
                NEXTSTEPBTN: "next-step",
                PREVSTEPBTN: "previous-step",
                STEPTITLE: "",
                STEP: "step",
                STEPCONTENT: "step-content",
                PRELOADERWRAPPER: "wait-feedback",
                FEEDBACKINGSTEP: "feedbacking",
                ACTIVESTEP: "active",
                WRONGSTEP: "wrong",
                DONESTEP: "done",
            }),
            (this.events = {
                STEPCHANGE: new Event("stepchange"),
                NEXTSTEP: new Event("nextstep"),
                PREVSTEP: new Event("prevstep"),
                STEPERROR: new Event("steperror"),
                FEEDBACKING: new Event("feedbacking"),
                FEEDBACKDESTROYED: new Event("feedbackdestroyed"),
            }),
            (this.listenerStore = []),
            (this.form = null),
            this._init();
    }
    return (
        _createClass(E, null, [
            {
                key: "addMultipleEventListeners",
                value: function value(e, t, n) {
                    var i =
                        3 < arguments.length &&
                        void 0 !== arguments[3] &&
                        arguments[3];
                    if (e instanceof Element)
                        return e.addEventListener(t, n, i);
                    for (var r = 0, s = e.length; r < s; r++) {
                        e[r].addEventListener(t, n, i);
                    }
                },
            },
            {
                key: "removeMultipleEventListeners",
                value: function value(e, t, n) {
                    var i =
                        3 < arguments.length &&
                        void 0 !== arguments[3] &&
                        arguments[3];
                    if (e instanceof Element)
                        return e.removeEventListener(t, n, i);
                    for (var r = 0, s = e.length; r < s; r++) {
                        e[r].removeEventListener(t, n, i);
                    }
                },
            },
            {
                key: "removeMultipleProperties",
                value: function value(e, t) {
                    for (var n = t.split(" "), i = 0; i < n.length; i++) {
                        e.style.removeProperty(n[i]);
                    }
                },
            },
            {
                key: "nodesIterator",
                value: function value(e, t) {
                    for (var n = 0; n < e.length; n++) {
                        t(e[n]);
                    }
                    return e;
                },
            },
            {
                key: "getUnknownHeight",
                value: function value(e) {
                    var t = e.cloneNode(!0);
                    (t.style.position = "fixed"),
                        (t.style.display = "block"),
                        (t.style.top = "-999999px"),
                        (t.style.left = "-999999px"),
                        (t.style.height = "auto"),
                        (t.style.opacity = "0"),
                        (t.style.zIndex = "-999999"),
                        (t.style.pointerEvents = "none"),
                        t
                            .querySelectorAll('[type="radio"]')
                            .forEach(function (e) {
                                e.name = "__" + e.name + "__";
                            });
                    var n = e.parentNode.insertBefore(t, e),
                        i = n.offsetHeight;
                    return e.parentNode.removeChild(n), i;
                },
            },
            // {
            //     key: "tabbingDisabler",
            //     value: function value(e) {
            //         9 === e.keyCode && e.preventDefault();
            //     },
            // },
        ]),
        E
    );
})();
window.Element &&
    !Element.prototype.closest &&
    (Element.prototype.closest = function (e) {
        var t,
            n = (this.document || this.ownerDocument).querySelectorAll(e),
            i = this;
        do {
            for (t = n.length; 0 <= --t && n.item(t) !== i; ) {}
        } while (t < 0 && (i = i.parentElement));
        return i;
    });

jQuery(function ($) {
  var chkdays = "";
  var chkdate = "";
  var formattedDate = "";
  var thirtyDays = "";
  var thirtyDaysFormatted = "";
  var date = "";
  var cal1 = "";
  var cal2 = "";
  var cal3 = "";
  var diffDays = "";
  var rounded = "";
  var day = "";
  var month = "";
  var monthName = "";
  var year = "";
  var dayOfWeek = "";
  var standardLimit = "";
  var standardLabor = "";
  var blockHeight = "";
  var accordHeight = "";
  var LaborCertFortyFive = "";
  var LaborCertFortyFiveFormatted = "";
  var heading1 = "";
  var heading2 = "";
  var emergencyLimit = "";
  var dateIcal = "";
  var appDate = "";
  var fortyFive = "";
  var chkdays_formatted = "";
  var acc_h3 = "";
  var acc_after_h3 = "";
  var acc2_h3 = "";
  var acc2_after_h3 = "";
  var acc3_h3 = "";
  var acc3_after_h3 = "";
  var acc4_h3 = "";
  var acc4_after_h3 = "";
  var acc5_h3 = "";
  var acc5_after_h3 = "";
  var acc6_h3 = "";
  var acc6_after_h3 = "";
  var acc7_h3 = "";
  var acc7_after_h3 = "";
  var acc8_h3 = "";
  var acc8_after_h3 = "";
  var acc9_h3 = "";
  var acc9_after_h3 = "";
  var acc10_h3 = "";
  var acc10_after_h3 = "";
  var asterisks = "";
  var formattedDate_Plaintext = "";
  var plaintext01 = "";
  var plaintext02 = "";
  var plaintext03 = "";
  var plaintext04 = "";
  var plaintext05 = "";
  var plaintext06 = "";
  var plaintext07 = "";
  var plaintext08 = "";
  var plaintext09 = "";
  var plaintext10 = "";
  var accordion_11 = "";
  var accordion_12 = "";
  var accordion_13 = "";
  var accordion_01_dom = "";
  var doc12 = "";
  var doc13 = "";
  var combined_accords = "";
  var blob = "";
  var accordionClasses = document.querySelectorAll(".Card-Accordion").length
    ? ".Card-Accordion"
    : ".usa-accordion.accordion-block-wrap.card";

  // Calculate time in one day
  var oneDay = 24 * 60 * 60 * 1000;
  var now = new Date();

  function calendarCreate() {
    const date = new Date();
    const picker = new Litepicker({
      element: document.getElementById("litepicker"),
      dropdowns: {
        minYear: date.getFullYear(),
        maxYear: date.getFullYear() + 2,
        months: true,
        years: true,
      },
      firstDay: 0,
      maxDate: dayjs(date).add(2, "year"),
      inlineMode: true,
      minDate: new Date() - 1,
    });

    picker.setDate(date);

    picker.on("selected", (date) => {
      reset();
      let selectedDate = dayjs(date.dateInstance);
      let today = dayjs();
      rounded = Math.ceil(selectedDate.diff(today, "day", true));
      setCalendarDisplayDate(date);
    });

    document
      .getElementById("litepicker")
      .addEventListener("keydown", (event) => {
        if (
          !!event.target.classList.contains("day-item") &&
          (event.code.toLowerCase() === "enter" ||
            event.code.toLowerCase() === "space")
        ) {
          event.target.click();
        }
      });
  }

  function setCalendarDisplayDate(date) {
    let formattedDate = !!date
      ? dayjs(date.dateInstance).format("M/D/YYYY")
      : dayjs().format("M/D/YYYY");

    const splitDate = formattedDate.toString().split("/");
    let dayNumber = !!date
      ? dayjs(date.dateInstance).get("day")
      : dayjs(date).get("day");

    day = splitDate[1];
    dayOfWeek = weekday[dayNumber];
    monthName = months[Number(splitDate[0]) - 1];
    year = splitDate[2];

    $("#date-dayname").text(dayOfWeek);
    $("#date-month").text(monthName);
    $("#date-day").text(day);
    $("#date-year").text(year);
  }

  function setDateFromDropdowns() {
    let selectedYear = document.querySelector(".month-item-year");
    let selectedMonth = document.querySelector(".month-item-name");
    let selectedDay = document.querySelector(".is-start-date");

    if (!!selectedYear && !!selectedMonth && !!selectedDay) {
      selectedDay = ("0" + selectedDay.innerText).slice(-2);
      selectedMonth = Number(selectedMonth.value) + 1;
      selectedMonth = ("0" + selectedMonth).slice(-2);

      return new Date(`${selectedMonth}/${selectedDay}/${selectedYear.value}`);
    }
  }

  // Reset the tool by removing everything
  function reset() {
    toggleChecklistButton(false);
    const checklist2 = document.querySelector(".checklist2");
    if (checklist2) {
      let calendar = document.querySelector(".step.calendar1")
        ? document.querySelector(".step.calendar1")
        : document.querySelector(".step.calendar2");
      if (calendar) calendar.classList.remove("complete");
    }

    $(
      "#checklist, .temp-ag-workers-lower-wrap .checklist-heading, .tool-line, #ext-txt"
    ).remove();
    $("#exp-all-sections").show();
    $(
      "#checklist-wrap, .usa-accordion.accordion-block-wrap.card, .Card-Accordion"
    ).hide();
    $("#print-sidebar, #calendar-reminder").show();
    $("#checklist-type").empty();
    $(".vis").removeClass("vis");
    $("#main-col").addClass("medium-9").removeClass("medium-6");
    $("#secondary-col").addClass("medium-3").removeClass("medium-6");
    $(".checklist-title").addClass("medium-9");
    $(".resource-links-block [class*='medium-']")
      .removeClass("medium-12")
      .addClass("medium-6");
    $(".resource-links-block [class*='medium-'] .resource-card")
      .removeClass("medium-6")
      .addClass("medium-12");
  }

  // Hide expand button if accordion content isn't tall enough to be expanded
  function setHeight() {
    $(".usa-accordion.accordion-block-wrap.vis")
      .find(".field--name-field-accordion-content")
      .each(function () {
        blockHeight = $(this);

        $(
          ".usa-accordion.accordion-block-wrap.vis .usa-accordion-content"
        ).each(function () {
          accordHeight = $(this).height();
        });

        if (blockHeight.height() < accordHeight) {
          blockHeight.parent().next(".usa-accordion-button").hide();
        }
      });
  }

  // Initiate stepper tool
  var stepper = document.querySelector(".stepper");
  var stepperInstance = new MStepper(stepper, {
    // options
    firstActive: 0, // this is the default
    // Allow navigation by clicking on the next and previous steps on linear steppers.
    linearStepsNavigation: true,
    // Auto focus on first input of each step.
    autoFocusInput: false,
    // Set if a loading screen will appear while feedbacks functions are running.
    showFeedbackPreloader: false,
    // Auto generation of a form around the stepper.
    autoFormCreation: true,
    // Function to be called everytime a nextstep occurs. It receives 2 arguments, in this sequece: stepperForm, activeStepContent.
    validationFunction: null,
    // Preloader used when step is waiting for feedback function. If not defined, Materializecss spinner-blue-only will be used.
    feedbackPreloader: '<div class="spinner-layer spinner-blue-only">...</div>',
  });

  // stepper.addEventListener("click", function () {
  //   stepper.style.marginBottom = "600px";
  //   // setTimeout(function () {
  //   //   stepper.style.marginBottom = "0";
  //   // }, 1000);
  // });
  const step2aQuestion =
    "Are you extending the contract of workers you are currently employing?";
  var step2a = `<li class="step" id="extend-contract">
    <div class="step-title">
      <h2>${step2aQuestion}</h2>
    </div>
    
    <div class="step-content">
      <fieldset class="no-border">
        <legend class="sr-only">${step2aQuestion}</legend>
        <div class="row step-2">    
          <label for="extend1" class="medium-4 radio-button-card xl">
            <div class="radio-button-card-text">
              <span>Yes</span>
            </div>
            <input type="radio" id="extend1" class="radio-button-input" name="extend-application" value="yes" aria-invalid="false">
          </label>
          <label for="extend2" class="medium-4 radio-button-card xl">
            <div class="radio-button-card-text">
              <span>No</span>
            </div>
            <input type="radio" id="extend2" class="radio-button-input" name="extend-application" value="no">
          </label>
        </fieldset>
      </div>
    </div>
  </li>`;

  var toastStandard = `<div id="alertSuccess" class="alert-call-out" style='display:none;'>
      <div class="alert-wrapper">
        <div class="usa-alert usa-alert-success">
            <div class="usa-alert-body">
                <div class="usa-alert-text">
                  <p>
                    Based on your responses, you should start the H-2A visa application process on <strong><span id="application-date">//</span></strong> by submitting the first form in the <strong>standard filing checklist.</strong>
                  </p>
                 </div>
                  </div>
              </div>
          </div>
      </div>`;

  var toastEmergency = `<div id="alertWarning" class="alert-call-out" style='display:none;'>
                <div class="alert-wrapper">
                    <div class="usa-alert usa-alert-error">
                        <div class="usa-alert-body">
                            <div class="usa-alert-text">
                                <p>Based on your responses, you should
                                  <strong>immediately</strong> begin the H-2A visa application process by completing the first step in the
                                  <strong>emergency filing checklist</strong>. <br>
                                  <br />
                                 <em> You'll need to provide justification for using this filing process.</em>
                                </p>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>`;

  var toastImmediate = `<div id="alertError" class="alert-call-out" style='display:none;'>
                  <div class="alert-wrapper">
                      <div class="usa-alert usa-alert-warning">
                          <div class="usa-alert-body">
                              <div class="usa-alert-text">
                                <p>Based on your responses, you should
                                  <strong>immediately</strong> begin the H-2A visa application process by taking these two actions:
                                <ol>
                                  <li>
                                    Send an email to the Department of Labor at
                                    <a href="mailto:tlc.chicago@dol.gov?subject=H-2A Program Question: Immediate Need for H-2A Workers." style="color:#49A564;" aria-label="Send email to Department of Labor Link">tlc.chicago@dol.gov</a>
                                    to ensure you have enough time to complete all H-2A visa program steps before your start date. Your email subject line should say "H-2A Program Question: Immediate Need for H-2A Workers."
                                  </li>
                                  <li>
                                    Begin the H-2A  visa application process immediately using the emergency filing process.
                                  </li>
                                </ol>
                                <br />
                                <em>You will need to provide justification for using the emergency filing process.</em>
                                </p>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>`;

  var toast = toastStandard + toastEmergency + toastImmediate;

  var step2b = `<li id="calendar" class="step visually-hidden">
                  <fieldset style="border: none;">
                      <div class="step-title">
                          <h2>
                              <legend>When do you need workers to start?</legend>
                          </h2>
                      </div>
                      <div class="step-content">
                        <p>
                          Select the specific date that your work is expected to start. 
                          This should match the start date you'll provide on your job order 
                          (ETA Form 790) for the State Workforce Agency as the first step 
                          in the H-2A visa hiring process. You can select a start date of 
                          up to two years from today.
                        </p>
                        <div id="date-outer-wrap">
                            <div id="date-wrap">
                                <div id="date-dayname"></div>
                                <div id="date-month"></div>
                                <div id="date-day"></div>
                                <div id="date-year"></div>
                            </div>
                            <div id="litepicker"></div>
                            <div id="date-footer">
                              <button id="date-ok" class="btn" tabindex="0">OK</button>
                            </div>
                          </div>
                      </div>
                  </fieldset>
              </li>`;

  var step3a = `<li class="step checklist1" id="checklist">
                    <div class="step-content">
                      <button id="checklist-btn" class="btn lg-btn" type="button" aria-label="View Your Checklist" tabindex="0">View Your Checklist</button>
                    </div>
                </li>`;
  var step3b = `<li class="step checklist2 visually-hidden" id="checklist">
      <div class="step-content">
        ${toast}
      </div>
    </li>`;

  // Extension Header Text
  var extension_txt = `<div id="ext-txt">
                          <p>
                            To extend the employment contract for current H-2A workers, you can file for either a short-term or 
                            long-term extension. You should file for a short-term extension if you need workers for two weeks or 
                            less and a long-term extension if you need workers for more than two weeks. You should submit a new 
                            H-2A visa application if you need to hire additional H-2A workers.
                          </p>
                          <div class="print-footer">
                            <a href="" id="print-page-3" onclick="return false;">Print the page</a>
                            <a href="#" id="download-text-only-3">Download a Text-Only Version of Your Checklist</a>
                          </div>
                      </div>';`;
  // Calendar text variables
  var fortyfive_long_desc =
    "To meet your deadline, apply for a labor certification with the Department of Labor’s Chicago National Processing Center by this date. You can complete this step after the State Workforce Agency has approved your job order. \\nBegin recruiting domestic workers immediately after you receive a Notice of Acceptance from the Chicago National Processing Center. They will provide you with specific instructions and recruiting requirements you will need to follow. \\nAnswer a few short questions on the H-2A Visa Checklist page (www.farmers.gov/manage/h2a/h2a-checklist) for additional information on these steps.";

  var seventyfive_long_desc =
    "To meet your deadline, submit a job order to your State Workforce Agency by this date. \\nAnswer a few short questions on the H-2A Visa Checklist page (www.farmers.gov/manage/h2a/h2a-checklist) for additional information on this step.";

  var thirty_long_desc =
    "During the remaining 30 days before workers arrive, you will need to: \\n* Receive a final determination from the Department of Labor’s Chicago National Processing Center * Submit your petition for a non-immigrant worker to US Citizenship and Immigration Services \\n* Find foreign workers \\nAfter these steps are completed, workers can apply for their H-2A Visas. \\nAnswer a few short questions on the H-2A Visa Checklist page (www.farmers.gov/manage/h2a/h2a-checklist) for additional information on these steps.";

  var work_start_long_desc =
    "Before the scheduled start date, workers can begin traveling from their home country to the work site.  Workers should arrive at the work site on the scheduled start date. \\nWorkers should complete a I-94 Arrival/Departure Record before traveling to the work site and carry it to and from the work site. When the worker arrives at the United States port of entry, an officer will stamp the I-94 with the approved entry and exit dates as well as the class of admission. \\nAnswer a few short questions on the H-2A Visa Checklist page (www.farmers.gov/manage/h2a/h2a-checklist) for additional information on these steps.";

  var emerg_var_long_desc =
    "To meet your deadline, submit a job order to your State Workforce Agency and apply for a labor certification with the Department of Labor’s Chicago National Processing Center immediately. \\nBegin recruiting domestic workers immediately after you receive a Notice of Acceptance from the Chicago National Processing Center. They will provide you with specific instructions and recruiting requirements you will need to follow. \\nAnswer a few short questions on the H-2A Visa Checklist page (www.farmers.gov/manage/h2a/h2a-checklist) for additional information on these steps.";

  var emerg_thirty_long_desc =
    "During the remaining 30 days before workers arrive, you will need to: \\n* Receive a final determination from the Department of Labor’s Chicago National Processing Center \\n* Submit your petition for a non-immigrant worker to US Citizenship and Immigration Services \\n* Find foreign workers \\nAfter these steps are completed, workers can apply for their H-2A Visas. \\nAnswer a few short questions on the H-2A Visa Checklist page (www.farmers.gov/manage/h2a/h2a-checklist) for additional information on these steps.";

  var emerg_work_start_long_desc =
    "Before the scheduled start date, workers can begin traveling from their home country to the work site.  Workers should arrive at the work site on the scheduled start date. \\nWorkers should complete a I-94 Arrival/Departure Record before traveling to the work site and carry it to and from the work site. When the worker arrives at the United States port of entry, an officer will stamp the I-94 with the approved entry and exit dates as well as the class of admission. \\nAnswer a few short questions on the H-2A Visa Checklist page (www.farmers.gov/manage/h2a/h2a-checklist) for additional information on this step.";

  var immed_work_start_long_desc =
    "Before the scheduled start date, workers can begin traveling from their home country to the work site.  Workers should arrive at the work site on the scheduled start date.\\n Workers should complete a I-94 Arrival/Departure Record before traveling to the work site and carry it to and from the work site. When the worker arrives at the United States port of entry, an officer will stamp the I-94 with the approved entry and exit dates as well as the class of admission. \\nAnswer a few short questions on the H-2A Visa Checklist page (www.farmers.gov/manage/h2a/h2a-checklist) for additional information on this step.";

  var immed_thirty_before_long_desc =
    "During the remaining 30 days before workers arrive, you will need to: \\n* Receive a final determination from the Department of Labor’s Chicago National Processing Center \\n* Submit your petition for a non-immigrant worker to US Citizenship and Immigration Services \\n* Find foreign workers \\nAfter these steps are completed, workers can apply for their H-2A Visas. \\nAnswer a few short questions on the H-2A Visa Checklist page (www.farmers.gov/manage/h2a/h2a-checklist) for additional information on these steps.";

  var immed_var_long_desc =
    "To meet your deadline, submit a job order to your State Workforce Agency and apply for a labor certification with the Department of Labor’s Chicago National Processing Center immediately. \\nYou should also email the Department of Labor at tlc.chicago@dol.gov to ensure you have enough time to complete the program steps before your start date. \\n Begin recruiting domestic workers immediately after you receive a Notice of Acceptance from the Chicago National Processing Center. They will provide you with specific instructions and recruiting requirements you will need to follow. \\nAnswer a few short questions on the H-2A Visa Checklist page (www.farmers.gov/manage/h2a/h2a-checklist) for additional information on these steps.";

  var immed_less_var_long_desc =
    "To meet your deadline, submit a job order to your State Workforce Agency and apply for a labor certification with the Department of Labor’s Chicago National Processing Center immediately. You should also email the Department of Labor at tlc.chicago@dol.gov to ensure you have enough time to complete the program steps before your start date.\\nBegin recruiting domestic workers immediately after you receive a Notice of Acceptance from the Chicago National Processing Center. They will provide you with specific instructions and recruiting requirements you will need to follow.\\nDuring the remaining days before workers arrive, you will need to:\\n* Receive a final determination from the Department of Labor’s Chicago National Processing Center\\n* Submit your petition for a non-immigrant worker to US Citizenship and Immigration Services \\n* Find foreign workers\\nAfter these steps are completed, workers can apply for their H-2A Visas.\\nAnswer a few short questions on the H-2A Visa Checklist page (www.farmers.gov/manage/h2a/h2a-checklist) for additional information on these steps.";

  var immed_less_work_start_long_desc =
    "Before the scheduled start date, workers can begin traveling from their home country to the work site.  Workers should arrive at the work site on the scheduled start date.\\nWorkers should complete a I-94 Arrival/Departure Record before traveling to the work site and carry it to and from the work site. When the worker arrives at the United States port of entry, an officer will stamp the I-94 with the approved entry and exit dates as well as the class of admission.\\nAnswer a few short questions on the H-2A Visa Checklist page (www.farmers.gov/manage/h2a/h2a-checklist) for additional information on this step.";

  // Assigning day and month names
  var weekday = new Array(7);
  weekday[0] = "Sunday";
  weekday[1] = "Monday";
  weekday[2] = "Tuesday";
  weekday[3] = "Wednesday";
  weekday[4] = "Thursday";
  weekday[5] = "Friday";
  weekday[6] = "Saturday";

  var months = new Array(12);
  months[0] = "JANUARY";
  months[1] = "FEBRUARY";
  months[2] = "MARCH";
  months[3] = "APRIL";
  months[4] = "MAY";
  months[5] = "JUNE";
  months[6] = "JULY";
  months[7] = "AUGUST";
  months[8] = "SEPTEMBER";
  months[9] = "OCTOBER";
  months[10] = "NOVEMBER";
  months[11] = "DECEMBER";

  function toggleChecklistButton(show) {
    const viewChecklistButton = document.getElementById("view-checklist");

    if (!!viewChecklistButton) {
      const newDisplayStyle = !!show ? "visible" : "hidden";
      if (!!show) {
        setTimeout(() => {
          viewChecklistButton.style.visibility = newDisplayStyle;
        }, 700);
      } else {
        viewChecklistButton.style.visibility = newDisplayStyle;
      }
    }
  }

  // First question "Yes"
  $(document).on("change", "#first1", function () {
    if ($(this).is(":checked")) {
      let selector = "#calendar";
      reset();
      $("#checklist").remove();

      // Add the next step after this step is checked
      var addedSteps = stepperInstance.activateStep(step2b, 1);

      // hideStep(stepperElement, selector);
      calendarCreate();
      setCalendarDisplayDate();

      // $('html, body').animate({
      //   scrollTop: $('#calendar').offset().top
      // }, 500);

      $("#calendar").addClass("calendar1");
      $(".step.first").addClass("complete");

      scrollToStep(stepperElement, selector);

      $("#date-ok").click(function (event) {
        const disabledButton = document.querySelector(
          "#checklist-btn.disabled"
        );
        if (!!disabledButton) disabledButton.classList.remove("disabled");

        let selector = "#checklist";
        event.preventDefault();
        hideStep(stepperElement, selector);
        // Only allow "OK" button to be clicked once
        if ($(this).hasClass("disabled")) {
          event.preventDefault();
          return false;
        }

        let today = new Date();
        today = new Intl.DateTimeFormat("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        }).format(today);

        var calDate = setDateFromDropdowns();

        // Do not allow multiple checklist buttons
        if (!$("#checklist").length) {
          stepperInstance.activateStep(step3b, 2);
          setToast(calDate, today);
          toggleChecklistButton(true);
        }
        let chkdays = 75;

        let standardLimit = dayjs(calDate).subtract(chkdays, "day");
        $("#application-date").text(dayjs(standardLimit).format("M/D/YYYY"));

        // $('html, body').animate({
        //   scrollTop: $('#checklist').offset().top - 0
        // }, 500);

        setTimeout(function () {
          $("#checklist").addClass("active complete");
          $("#date-ok").blur();
        }, 600);

        scrollToStep(stepperElement, "#checklist");
      });

      if ($("#extend-contract").length) {
        $("#extend-contract").remove();
      }

      if ($(".calendar2").length) {
        $(".calendar2").remove();
      }
    } else {
      reset();
    }
  });

  const stepperElement = document.querySelector(".stepper");

  function hideStep(stepperElement, selector) {
    $(selector).addClass("visually-hidden");
    stepperElement.style.marginBottom = $(selector).height + "px";
  }

  function scrollToStep(stepperElement, selector) {
    setTimeout(function () {
      $(selector).removeClass("visually-hidden");
      stepperElement.style.marginBottom = "0";

      let activeLinks = document.querySelectorAll(".step.active");
      activeLinks.forEach(function (link, index) {
        if (activeLinks.length - 1 !== index) link.classList.add("complete");
      });

      $(selector)[0].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 600);
  }

  // First question "No"
  $(document).on("change", "#first2", function () {
    if ($(this).is(":checked")) {
      let selector = "#extend-contract";
      var addedSteps = stepperInstance.activateStep(step2a, 1);

      hideStep(stepperElement, selector);
      $(selector).addClass("active");

      reset();
      $("#calendar").remove();
      $(".step.active.first").addClass("active");
      // $('html, body').animate({
      //   scrollTop: $('#extend-contract').offset().top - 50
      // }, 500);

      scrollToStep(stepperElement, selector);
    } else {
      reset();
    }
  });

  // Extension question "Yes"
  $(document).on("change", "#extend1", function () {
    if ($(this).is(":checked")) {
      let selector = "#checklist";
      reset();
      diffDays = "";
      $(".step.active").addClass("active complete");
      stepperInstance.activateStep(step3a, 2);
      $(selector).addClass("active");
      //           $('html, body').animate({
      //     scrollTop: $('#checklist').offset().top - 50
      // }, 500);
      $(selector)[0].scrollIntoView({ behavior: "smooth", block: "start" });

      if ($("#calendar").length) {
        $("#calendar").remove();
      }
    } else {
    }
  });

  // Extension question "No"
  $(document).on("change", "#extend2", function () {
    if ($(this).is(":checked")) {
      let selector = "#calendar";
      reset();

      $(".step.active").addClass("active");

      var addedSteps = stepperInstance.activateStep(step2b, 2);

      calendarCreate();
      setCalendarDisplayDate();

      hideStep(stepperElement, selector);
      $("#calendar").addClass("calendar2");

      // $('html, body').animate({
      //   scrollTop: $('#calendar').offset().top - 0
      // }, 500);

      scrollToStep(stepperElement, selector);

      $("#date-ok").click(function (event) {
        const disabledButton = document.querySelector(
          "#checklist-btn.disabled"
        );
        if (!!disabledButton) disabledButton.classList.remove("disabled");

        let selector = "#checklist";
        hideStep(stepperElement, selector);

        event.preventDefault();

        // Only allow "OK" button to be clicked once
        if ($(this).hasClass("disabled")) {
          event.preventDefault();
          return false;
        }

        let today = new Date();
        today = new Intl.DateTimeFormat("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        }).format(today);

        var calDate = setDateFromDropdowns();

        // Do not allow multiple chcklist buttons
        if (!$(selector).length) {
          stepperInstance.activateStep(step3b, 3);
          setToast(calDate, today);
          toggleChecklistButton(true);
        }

        let standardLimit = dayjs(calDate).subtract(75, "day");
        $("#application-date").text(dayjs(standardLimit).format("M/D/YYYY"));

        // $('html, body').animate({
        //   scrollTop: $('#checklist').offset().top - 0
        // }, 500);
        setTimeout(function () {
          $(selector).addClass("active complete");
          $("#date-ok").blur();
        }, 600);
        scrollToStep(stepperElement, selector);
      });
    } else {
      // console.log('Unchecked');
    }
  });

  // Final "View Your Checklist" button. This button triggers all date output for the tool.
  $(document).on("click", "#checklist-btn", function (evt) {
    $(".temp-ag-workers-lower-wrap").show();

    if ($("#checklist-btn").hasClass("disabled")) {
      evt.preventDefault();
      return false;
    }

    $("#checklist-btn").addClass("disabled").attr("disabled", "disabled");

    var today = new Date();
    today = new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    }).format(today);

    var calDate = setDateFromDropdowns();

    calDate = calDate ? dayjs(calDate) : null;
    today = dayjs(today);
    let diffDays = calDate ? calDate.diff(today, "day") : 0;

    // Logic between days ranges
    // If days selected is more than 74.1 days before todays date
    if (diffDays >= 74.1) {
      console.log("Standard");
      $("#checklist-type").text("Standard Checklist");
      $(".standard-timeline").addClass("vis").show();
      chkdays = 75;
      standardLimit = dayjs(calDate).subtract(75, "day");
      formattedDate = dayjs(standardLimit).format("MMM D, YYYY"); //formattedDate is 75 days before

      dateIcal = dayjs(calDate).format("MM/DD/YYYY");
      fortyFive = 45;
      standardLabor = dayjs(calDate).subtract(fortyFive, "day");
      LaborCertFortyFive = dayjs(standardLabor).format("MMM D, YYYY");
      LaborCertFortyFiveFormatted = dayjs(standardLabor).format("MM/DD/YYYY");
      chkdate = dayjs(calDate).subtract(30, "day");
      thirtyDays = dayjs(chkdate).format("MMM D, YYYY");
      thirtyDaysFormatted = dayjs(chkdate).format("MM/DD/YYYY");
      var newdate = new Date(date);
      // appDate is 75 days before and is formatted for iCal
      // LaborCertFortyFiveFormatted is 45 days before and is formatted for iCal
      // thirtyDaysFormatted is 30 days before and is formatted for iCal
      // dateIcal is the actual date of work and is formatted for iCal
      $(".final-determination").before(
        `<div class="checklist-heading" id="chk-heading-2">
            <div class="chk-date" aria-label="${thirtyDays}">
              ${thirtyDays}
              </div>
              <h3>No Later Than <span id="chk-days">30</span> Days Before Work Starts</h3>
            </div>
            <div class="tool-line top-line"></div>`
      );
      $(".labor-certificate").before(
        `<div class="checklist-heading" id="chk-heading-4">
            <div class="chk-date" aria-label="${LaborCertFortyFive}">
              ${LaborCertFortyFive}
            </div>
              <h3>No Later Than <span id="chk-days">${fortyFive}</span> Days Before Work Starts</h3>
          </div>
          <div class="tool-line top-line"></div>`
      );
      $(accordionClasses + ":first").before(
        `<div class="checklist-heading" id="chk-heading-1">
          <div class="chk-date" aria-label="${formattedDate}">
            ${formattedDate} 
          </div>
          <h3><span id="chk-days">${chkdays}</span> Days Before Work Starts</h3>
        </div>
        <div class="tool-line first-line"></div>`
      );

      var ical_appdate = dayjs(standardLimit).format("YYYYMMDD");
      var ical_45days = dayjs(standardLabor).format("YYYYMMDD");
      var ical_30days = dayjs(chkdate).format("YYYYMMDD");
      var ical_00days = dayjs(calDate).format("YYYYMMDD");

      var date_cal_base =
        "data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0d%0aVERSION:2.0%0d%0aPRODID:-//ZContent.net//Zap Calendar 1.0//EN";

      var date_cal_75 =
        "%0d%0aBEGIN:VEVENT%0d%0aUID:937118b4151fs85804a1wed187d34c2f%0d%0aSUMMARY:H-2A: 75 days before work starts%0d%0aDTSTART:" +
        ical_appdate +
        /*'%0d%0aDTEND:' + ical_appdate +*/ "%0d%0aDTSTAMP:" +
        ical_appdate +
        "T110309%0d%0aDESCRIPTION:" +
        seventyfive_long_desc +
        "%0d%0aEND:VEVENT";
      var date_cal_45 =
        "%0d%0aBEGIN:VEVENT%0d%0aUID:937118b41511285804a1e1d187d34c2f%0d%0aSUMMARY:H-2A: No Later Than 45 days before work starts%0d%0aDTSTART:" +
        ical_45days +
        "%0d%0aDTEND:" +
        ical_45days +
        "%0d%0aDTSTAMP:" +
        ical_appdate +
        "T110309%0d%0aDESCRIPTION:" +
        fortyfive_long_desc +
        "%0d%0aEND:VEVENT";
      var date_cal_30 =
        "%0d%0aBEGIN:VEVENT%0d%0aUID:937118b4151fs85804a1e1d14rd34c2f%0d%0aSUMMARY:H-2A: No Later Than 30 days before work starts%0d%0aDTSTART:" +
        ical_30days +
        "%0d%0aDTEND:" +
        ical_30days +
        "%0d%0aDTSTAMP:" +
        ical_appdate +
        "T110309%0d%0aDESCRIPTION:" +
        immed_thirty_before_long_desc +
        "%0d%0aEND:VEVENT";
      var date_cal_00 =
        "%0d%0aBEGIN:VEVENT%0d%0aUID:937118b4140fs85804a1e1d127d34c2f%0d%0aSUMMARY:H-2A: First day of work%0d%0aDTSTART:" +
        ical_00days +
        "%0d%0aDTEND:" +
        ical_00days +
        "%0d%0aDTSTAMP:" +
        ical_appdate +
        "T110309%0d%0aDESCRIPTION:" +
        work_start_long_desc +
        "%0d%0aEND:VEVENT";

      var date_cal_end = "%0d%0aEND:VCALENDAR";

      var standard_date_cal_events =
        date_cal_75 + date_cal_45 + date_cal_30 + date_cal_00;

      $(document).off("click", "#cal-download-1-ios");
      $(document).on("click", "#cal-download-1-ios", function (evt) {
        $("#cal-download-1-ios").wrapAll(
          '<a id="linkcal01" href="' +
            date_cal_base +
            standard_date_cal_events +
            date_cal_end +
            '" target="_blank"></a>'
        );
        $("#linkcal01")[0].click();
        $("#linkcal01").children().unwrap();
      });

      $(document).off("click", "#cal-download-2-ios");
      $(document).on("click", "#cal-download-2-ios", function (evt) {
        $("#cal-download-2-ios").wrapAll(
          '<a id="linkcal02" href="' +
            date_cal_base +
            standard_date_cal_events +
            date_cal_end +
            '" target="_blank"></a>'
        );
        $("#linkcal02")[0].click();
        $("#linkcal02").children().unwrap();
      });

      getdate = dayjs(calDate).format("MMM D, YYYY");

      $(accordionClasses + ".travel-to-worksite:visible").before(
        '<div class="checklist-heading" id="chk-heading-3"><div class="chk-date" aria-label="' +
          getdate +
          '">' +
          getdate +
          '</div><h2>First Day of Work</h2></div><div class="tool-line top-line"></div>'
      );
      $(accordionClasses + ":visible:not(:first)").before(
        '<div class="tool-line"></div>'
      );

      // If days selected is less than 74 days but more than 45 days
    } else if (diffDays <= 74.0 && diffDays >= 45.0) {
      console.log("Emergency");
      $("#checklist-type").text("Emergency Checklist");
      $(".emergency-timeline").addClass("vis").show();

      chkdays = Math.round(rounded);
      // console.log({ chkdays: chkdays });
      emergencyLimit = dayjs(calDate).subtract(chkdays, "day");
      chkdate = dayjs(calDate).subtract(30, "day");
      dateIcal = dayjs(calDate).format("MMM/DD/YYYY");
      formattedDate = dayjs(emergencyLimit).format("MMM D, YYYY");
      thirtyDays = dayjs(chkdate).format("MMM D, YYYY");
      thirtyDaysFormatted = dayjs(chkdate).format("MM/DD/YYYY");
      chkdays_formatted = dayjs(calDate).format("MM/DD/YYYY");
      var newdate = new Date(calDate);

      $(".final-determination").before(
        `<div class="checklist-heading" id="chk-heading-2">
          <div class="chk-date" aria-label="${thirtyDays}">
            ${thirtyDays}
          </div>
            <h2>
              No Later Than <span id="chk-days">30</span> Days Before Work Starts
            </h2>
          </div>
          <div class="tool-line top-line"></div>`
      );
      $(accordionClasses + ":first").before(
        `<div class="checklist-heading" id="chk-heading-1">
          <div class="chk-date" aria-label="${formattedDate}">
            ${formattedDate}
          </div>
          <h2>
            <span id="chk-days" aria-lable="${chkdays}">${chkdays}</span> Days Before Work Starts
          </h2>
        </div>
        <div class="tool-line first-line"></div>`
      );

      getdate = dayjs(calDate).format("MMM D, YYYY");

      $(accordionClasses + ".travel-to-worksite:visible").before(
        `<div class="checklist-heading" id="chk-heading-3">
            <div class="chk-date" aria-label="${getdate}">
              ${getdate}
            </div>
            <h2>First Day of Work</h2>
          </div>
          <div class="tool-line top-line"></div>`
      );
      $(accordionClasses + ":visible:not(:first)").before(
        '<div class="tool-line"></div>'
      );

      // Calendar reminders
      var ical_emergdyn = dayjs(emergencyLimit).format("YYYYMMDD");
      var ical_emerg30 = dayjs(chkdate).format("YYYYMMDD");
      var ical_emerg00 = dayjs(calDate).format("YYYYMMDD");

      var e_date_cal_base =
        "data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0d%0aVERSION:2.0%0d%0aPRODID:-//ZContent.net//Zap Calendar 1.0//EN";

      var e_date_cal_dyn =
        "%0d%0aBEGIN:VEVENT%0d%0aUID:937118b4151fs85804a1wed187d34c2f%0d%0aSUMMARY:H-2A: " +
        chkdays +
        " days before work starts%0d%0aDTSTART:" +
        ical_emergdyn +
        "%0d%0aDTEND:" +
        ical_emergdyn +
        "%0d%0aDESCRIPTION:" +
        emerg_var_long_desc +
        "%0d%0aEND:VEVENT";
      var e_date_cal_30 =
        "%0d%0aBEGIN:VEVENT%0d%0aUID:937118b4151fs85804a1e1d14rd34c2f%0d%0aSUMMARY:H-2A: No Later Than 30 days before work starts%0d%0aDTSTART:" +
        ical_emerg30 +
        "%0d%0aDTEND:" +
        ical_emerg30 +
        "%0d%0aDESCRIPTION:" +
        emerg_thirty_long_desc +
        "%0d%0aEND:VEVENT";
      var e_date_cal_00 =
        "%0d%0aBEGIN:VEVENT%0d%0aUID:937118b4140fs85804a1e1d127d34c2f%0d%0aSUMMARY:H-2A: First day of work%0d%0aDTSTART:" +
        ical_emerg00 +
        "%0d%0aDTEND:" +
        ical_emerg00 +
        "%0d%0aDESCRIPTION:" +
        emerg_work_start_long_desc +
        "%0d%0aEND:VEVENT";

      var e_date_cal_end = "%0d%0aEND:VCALENDAR";

      var emerg_date_cal_events =
        e_date_cal_dyn + e_date_cal_30 + e_date_cal_00;

      $(document).off("click", "#cal-download-1-ios");
      $(document).on("click", "#cal-download-1-ios", function (evt) {
        $("#cal-download-1-ios").wrapAll(
          '<a id="linkcal03" href="' +
            e_date_cal_base +
            emerg_date_cal_events +
            e_date_cal_end +
            '" target="_blank"></a>'
        );
        $("#linkcal03")[0].click();
        $("#linkcal03").children().unwrap();
      });

      $(document).off("click", "#cal-download-2-ios");
      $(document).on("click", "#cal-download-2-ios", function (evt) {
        $("#cal-download-2-ios").wrapAll(
          '<a id="linkcal04" href="' +
            e_date_cal_base +
            emerg_date_cal_events +
            e_date_cal_end +
            '" target="_blank"></a>'
        );
        // $("#cal-download-1-ios, #cal-download-2-ios").append('<a id="linkcal" href="' + e_date_cal_base + emerg_date_cal_events + e_date_cal_end + '" target="_blank">&nbsp</a>');
        $("#linkcal04")[0].click();
        $("#linkcal04").children().unwrap();
      });

      // If days selected is less than 74 days but more than 45 days
    } else if (
      (diffDays <= 44.9 && diffDays >= 0.001) ||
      (!!calDate &&
        dayjs(today).format("YYYY-MM-DD") === calDate.format("YYYY-MM-DD"))
    ) {
      console.log("\nImmediate Need");
      $("#checklist-type").text("Immediate Checklist");
      $(".immediate-timeline").addClass("vis").show();
      formattedDate = dayjs(now).format("MMM D, YYYY");

      chkdays = Math.round(rounded);

      var dateImmed = calDate;
      var chkdate2 = dayjs(dateImmed).subtract(30, "day");
      var chkdate3 = dayjs(dateImmed).subtract(chkdays, "day");
      var dateIcalImmed = dayjs(dateImmed).format("MM/DD/YYYY");
      var thirtyImmed = dayjs(chkdate2).format("MM/DD/YYYY");
      var variImmed = dayjs(chkdate3).format("MM/DD/YYYY");

      // If the days before work starts is calculated less than one (usually a half day or part of a day) then just make that 1 day.
      if (chkdays < 1) {
        chkdays = 1;
        $(accordionClasses + ":first").before(
          '<div class="checklist-heading" id="chk-heading-1"><div class="chk-date" aria-label="' +
            formattedDate +
            '">' +
            formattedDate +
            '</div><h2><span id="chk-days" aria-label="' +
            chkdays +
            '">' +
            chkdays +
            '</span> Day Before Work Starts</h2></div><div class="tool-line first-line"></div>'
        );
      } else {
        $(accordionClasses + ":first").before(
          '<div class="checklist-heading" id="chk-heading-1"><div class="chk-date" aria-label="' +
            formattedDate +
            '">' +
            formattedDate +
            '</div><h2><span id="chk-days" aria-label="' +
            chkdays +
            '">' +
            chkdays +
            '</span> Days Before Work Starts</h2></div><div class="tool-line first-line"></div>'
        );
      }
      chkdate = dayjs(now).add(chkdays, "day");
      getdate = dayjs(calDate).format("MMM D, YYYY");

      $(accordionClasses + ".travel-to-worksite:visible").before(
        '<div class="checklist-heading" id="chk-heading-3"><div class="chk-date" aria-label="' +
          getdate +
          '">' +
          getdate +
          '</div><h2>First Day of Work</h2></div><div class="tool-line top-line"></div>'
      );
      $(accordionClasses + ":visible:not(:first)").before(
        '<div class="tool-line"></div>'
      );

      if (chkdays >= 30) {
        var ical_immeddyn_a = dayjs(calDate).format("YYYYMMDD");
        var ical_immed30_a = dayjs(chkdate2).format("YYYYMMDD");
        var ical_immed00_a = dayjs(dateImmed).format("YYYYMMDD");
        var i_date_cal_base_a =
          "data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0d%0aVERSION:2.0%0d%0aPRODID:-//ZContent.net//Zap Calendar 1.0//EN";
        //Commented this out as we only need 2 reminders for Immediate for both less than and greater than 30 days.  Content may not be correct now, but
        // the functionaility should be.
        // var i_date_cal_dyn_a = '%0d%0aBEGIN:VEVENT%0d%0aUID:937118b4151fs85804a1wed187d34c2f%0d%0aSUMMARY:H-2A: ' + chkdays + ' days before work starts%0d%0aDTSTART:' + ical_immeddyn_a +  '%0d%0aDTEND:' + ical_immeddyn_a + "%0d%0aDESCRIPTION:" + immed_var_long_desc + "%0d%0aEND:VEVENT";
        var i_date_cal_30_a =
          "%0d%0aBEGIN:VEVENT%0d%0aUID:937118b4151fs85804a1e1d14rd34c2f%0d%0aSUMMARY:H-2A: No Later Than 30 days before work starts%0d%0aDTSTART:" +
          ical_immed30_a +
          "%0d%0aDTEND:" +
          ical_immed30_a +
          "%0d%0aDESCRIPTION:" +
          immed_thirty_before_long_desc +
          "%0d%0aEND:VEVENT";
        var i_date_cal_00_a =
          "%0d%0aBEGIN:VEVENT%0d%0aUID:937118b4140fs85804a1e1d127d34c2f%0d%0aSUMMARY:H-2A: First day of work%0d%0aDTSTART:" +
          ical_immed00_a +
          "%0d%0aDTEND:" +
          ical_immed00_a +
          "%0d%0aDESCRIPTION:" +
          immed_work_start_long_desc +
          "%0d%0aEND:VEVENT";

        var i_date_cal_end_a = "%0d%0aEND:VCALENDAR";
        var immed_date_cal_events_a = i_date_cal_30_a + i_date_cal_00_a;

        $(document).off("click", "#cal-download-1-ios");
        $(document).on("click", "#cal-download-1-ios", function (evt) {
          $("#cal-download-1-ios").wrapAll(
            '<a id="linkcal05" href="' +
              i_date_cal_base_a +
              immed_date_cal_events_a +
              i_date_cal_end_a +
              '" target="_blank"></a>'
          );
          $("#linkcal05")[0].click();
          $("#linkcal05").children().unwrap();
        });

        $(document).off("click", "#cal-download-2-ios");
        $(document).on("click", "#cal-download-2-ios", function (evt) {
          $("#cal-download-2-ios").wrapAll(
            '<a id="linkcal06" href="' +
              i_date_cal_base_a +
              immed_date_cal_events_a +
              i_date_cal_end_a +
              '" target="_blank"></a>'
          );
          $("#linkcal06")[0].click();
          $("#linkcal06").children().unwrap();
        });
      } else if (chkdays < 30) {
        var ical_immeddyn_b = dayjs(chkdate3).format("YYYYMMDD");
        var ical_immed00_b = dayjs(dateImmed).format("YYYYMMDD");

        var i_date_cal_base_b =
          "data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0d%0aVERSION:2.0%0d%0aPRODID:-//ZContent.net//Zap Calendar 1.0//EN";

        var i_date_cal_dyn_b =
          "%0d%0aBEGIN:VEVENT%0d%0aUID:937118b4151fs85804a1wed187d34c2f%0d%0aSUMMARY:H-2A: " +
          chkdays +
          " days before work starts%0d%0aDTSTART:" +
          ical_immeddyn_b +
          "%0d%0aDTEND:" +
          ical_immeddyn_b +
          "%0d%0aDESCRIPTION:" +
          immed_less_var_long_desc +
          "%0d%0aEND:VEVENT";
        var i_date_cal_00_b =
          "%0d%0aBEGIN:VEVENT%0d%0aUID:937118b4140fs85804a1e1d127d34c2f%0d%0aSUMMARY:H-2A: First day of work%0d%0aDTSTART:" +
          ical_immed00_b +
          "%0d%0aDTEND:" +
          ical_immed00_b +
          "%0d%0aDESCRIPTION:" +
          immed_less_work_start_long_desc +
          "%0d%0aEND:VEVENT";

        var i_date_cal_end_b = "%0d%0aEND:VCALENDAR";

        var immed_date_cal_events_b = i_date_cal_dyn_b + i_date_cal_00_b;

        $(document).off("click", "#cal-download-1-ios");
        $(document).on("click", "#cal-download-1-ios", function (evt) {
          $("#cal-download-1-ios").wrapAll(
            '<a id="linkcal07" href="' +
              i_date_cal_base_b +
              immed_date_cal_events_b +
              i_date_cal_end_b +
              '" target="_blank"></a>'
          );
          $("#linkcal07")[0].click();
          $("#linkcal07").children().unwrap();
        });

        $(document).off("click", "#cal-download-2-ios");
        $(document).on("click", "#cal-download-2-ios", function (evt) {
          $("#cal-download-2-ios").wrapAll(
            '<a id="linkcal08" href="' +
              i_date_cal_base_b +
              immed_date_cal_events_b +
              i_date_cal_end_b +
              '" target="_blank"></a>'
          );
          $("#linkcal08")[0].click();
          $("#linkcal08").children().unwrap();
        });
      }
    } else if (diffDays === 0) {
      var isMobile = false; //initiate as false
      // device detection
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
          navigator.userAgent
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          navigator.userAgent.substr(0, 4)
        )
      ) {
        isMobile = true;
      }

      if (isMobile) {
        $("#checklist-type").text("Extension Checklists");
        $(".step.active").addClass("active");
        $("#checklist").addClass("active");
        $("#checklist-title").removeClass("usa-width-three-fourths");

        $(
          ".short-term-extension, .long-term-extension, .submit-a-petition, .contact-labor-dept"
        )
          .addClass("vis")
          .show();

        $(
          "#exp-all-sections, #calendar-reminder, #calendar-reminder-footer, #print-sidebar, .short-term-extension h3, .long-term-extension h3"
        ).hide();
        $("#secondary-col").removeClass("usa-width-one-fourth");
        $(".short-term-extension .usa-accordion-content").attr(
          "aria-hidden",
          "true"
        );
        $("#secondary-col").show();

        $(".temp-ag-workers-lower-wrap .long-term-extension").appendTo(
          "#secondary-col"
        );
        $(".temp-ag-workers-lower-wrap .submit-a-petition").appendTo(
          "#secondary-col"
        );
        $(".temp-ag-workers-lower-wrap .contact-labor-dept").appendTo(
          "#secondary-col"
        );
        $(
          ".paragraph.paragraph--type-block.paragraph--view-mode-default"
        ).insertAfter($("#bottom-content").parent());
        $(".resource-links-block > .usa-width-one-half")
          .removeClass("usa-width-one-half")
          .addClass("usa-width-three-fourths");
        $(
          "#secondary-col .usa-accordion.accordion-block-wrap.card:visible:not(:first)"
        ).before('<div class="tool-line"></div>');

        $(extension_txt).appendTo("#checklist-title");

        heading1 = $(".short-term-extension .field--name-field-title").text();
        $(".short-term-extension").before(
          '<div class="checklist-heading extension" id="chk-heading-1"><div class="chk-date">2 Weeks or Less</div><h2>' +
            heading1 +
            '</h2></div><div class="tool-line first-line"></div>'
        );
        heading2 = $(".long-term-extension .field--name-field-title").text();
        $(".long-term-extension").before(
          '<div class="checklist-heading extension" id="chk-heading-2"><div class="chk-date">More Than 2 Weeks</div><h2>' +
            heading2 +
            '</h2></div><div class="tool-line first-line"></div>'
        );
        //
      } else {
        $("#checklist-type").text("Extension Checklists");
        $(".step.active").addClass("active");
        $("#checklist").addClass("active");
        $("#checklist-title").removeClass("usa-width-three-fourths");
        $(
          ".short-term-extension, .long-term-extension, .submit-a-petition, .contact-labor-dept"
        )
          .addClass("vis")
          .show();

        $(
          ".short-term-extension  .card-accordion-content, .long-term-extension  .card-accordion-content"
        ).addClass("show");

        $("#main-col")
          .removeClass("usa-width-three-fourths")
          .removeClass("medium-9")
          .addClass("usa-width-one-half")
          .addClass("medium-6");
        $(
          "#exp-all-sections, #calendar-reminder, #calendar-reminder-footer, #print-sidebar, .short-term-extension .usa-accordion-button, .short-term-extension h3, .long-term-extension h3, .long-term-extension .usa-accordion-button"
        ).hide();
        $("#secondary-col")
          .removeClass("usa-width-one-fourth")
          .removeClass("medium-9")
          .addClass("usa-width-one-half")
          .addClass("medium-6");
        $(".checklist-title").removeClass("medium-9");

        $(".resource-links-block [class*='medium-']")
          .addClass("medium-12")
          .removeClass("medium-6");

        $(".resource-links-block [class*='medium-'] .resource-card")
          .addClass("medium-12")
          .removeClass("usa-width-one-half")
          .removeClass("medium-6");
        $(".short-term-extension .usa-accordion-content").attr(
          "aria-hidden",
          "false"
        );
        $(".temp-ag-workers-lower-wrap .long-term-extension").appendTo(
          "#secondary-col"
        );
        $(".temp-ag-workers-lower-wrap .submit-a-petition").appendTo(
          "#secondary-col"
        );
        $(".temp-ag-workers-lower-wrap .contact-labor-dept").appendTo(
          "#secondary-col"
        );
        $(
          "#secondary-col .usa-accordion.accordion-block-wrap.card:visible:not(:first)"
        ).before('<div class="tool-line"></div>');

        $(extension_txt).appendTo("#checklist-title");
        heading1 = $(".short-term-extension .field--name-field-title").text();
        $(".short-term-extension").before(
          '<div class="checklist-heading extension" id="chk-heading-1"><div class="chk-date">2 Weeks or Less</div><h2>' +
            heading1 +
            '</h2></div><div class="tool-line first-line"></div>'
        );
        heading2 = $(".long-term-extension .field--name-field-title").text();
        $(".long-term-extension").before(
          '<div class="checklist-heading extension" id="chk-heading-2"><div class="chk-date">More Than 2 Weeks</div><h2>' +
            heading2 +
            '</h2></div><div class="tool-line first-line"></div>'
        );
      }
    }

    $("#checklist-wrap")[0].scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    // Check to see if the content in each visible accordion is tall enough to be expanded and hide the expand button if it's not
    setHeight();
  });

  function setToast(calDate, today) {
    calDate = dayjs(calDate);
    today = dayjs(today);

    var diffDays = calDate.diff(today, "day");

    if (diffDays >= 74.1) {
      $("#alertSuccess").show();
    } else if (diffDays <= 74.0 && diffDays >= 45.0) {
      $("#alertError").show();
    } else if ((diffDays <= 44.9 && diffDays >= 0) || today === calDate) {
      $("#alertWarning").show();
    }
  }

  // Get correct calendar reminder files based on date and checklist
  // $('#cal-download-1, #calendar-download-2').click(function(event){
  //   if (diffDays >= 74.1) {
  //     cal1.download('H2A_standard_checklist');
  //   } else if (diffDays <= 74.0 && diffDays >= 45.0) {
  //     cal2.download('H2A_emergency_checklist');
  //   } else if (diffDays <= 44.9 && diffDays >= 0.001 || today == calDate) {

  //     cal3.download('H2A_immediate_checklist_1');
  //   }
  // });

  // This exapands all closed accordion areas and collapses them
  $("#exp-all-sections").on("click keypress", function (event) {
    if (event.keyCode && event.keyCode !== 13) return;

    // design site
    const DSAccordionsContent = document.querySelectorAll(
      ".Card-Accordion .card-accordion"
    );
    const DSAccordionsToggle = document.querySelectorAll(
      ".Card-Accordion .card-accordion-toggle a"
    );

    $(this).toggleClass("active");
    if ($(this).hasClass("active")) {
      $("#exp-all-sections a").text("Collapse All Sections");
      $("#exp-all-sections span").text("-");
      $(
        '.accordion-block-wrap .usa-accordion-button:not([aria-expanded="true"])'
      ).click();

      DSAccordionsContent.forEach(function (content) {
        content.classList.add("show");
      });
      DSAccordionsToggle.forEach(function (content) {
        content.classList.add("card-accordion-show-less");
        content.innerHTML = "Show Less";
      });
    } else {
      $("#exp-all-sections a").text("Expand All Sections");
      $("#exp-all-sections span").text("+");
      $(
        '.accordion-block-wrap .usa-accordion-button:not([aria-expanded="false"])'
      ).click();
      $(".card-accordion-toggle a").click();

      DSAccordionsContent.forEach(function (content) {
        content.classList.remove("show");
      });
      DSAccordionsToggle.forEach(function (content) {
        content.classList.remove("card-accordion-show-less");
        content.innerHTML = "Show More";
      });
    }
  });

  // This is to prevent individual steps from becoming inactive.
  $(".step.active").click(function () {
    $(this).addClass("active");
  });

  // Click to print
  $(document).on(
    "click",
    "#print-page-1, #print-page-2, #print-page-3",
    function () {
      const accordionContent = document.querySelectorAll(
        ".card-accordion-content"
      );
      if (accordionContent) {
        accordionContent.forEach(function (content) {
          content.classList.add("show");
        });
      }
      window.print();
      return false;
    }
  );
  window.onafterprint = function () {
    const accordionContent = document.querySelectorAll(
      ".card-accordion-content"
    );
    if (accordionContent) {
      accordionContent.forEach(function (content) {
        content.classList.remove("show");
      });
    }
  };
  $(document).on("click", "#download-text-only-3", function () {
    if ($(".plaintext-10").hasClass("vis")) {
      var plaintext_ext_less = $("#chk-heading-1 .chk-date").text();
      var acc10_h3 = $(".plaintext-10 > div > h3 > div").text();
      $(".plaintext-10 > div > div")
        .find("a:not([href='#'])")
        .each(function () {
          // Set the innerHTML value of each Anchor element to it's own HREF
          $(this).html($(this).attr("href"));
        });
      var acc10_after_h3 = $(".plaintext-10 > div  > div").text();
      var plaintext10 =
        "\n\n-- " +
        plaintext_ext_less +
        "\t" +
        acc10_h3 +
        " --" +
        "\n\n" +
        acc10_after_h3;
    }
    if ($(".plaintext-11").hasClass("vis")) {
      var plaintext_ext_more = $("#chk-heading-2 .chk-date").text();
      var acc11_h3 = $(".plaintext-11 > div > h3 > div").text();
      $(".plaintext-11 > div > div")
        .find("a:not([href='#'])")
        .each(function () {
          // Set the innerHTML value of each Anchor element to it's own HREF
          $(this).html($(this).attr("href"));
        });
      var acc11_after_h3 = $(".plaintext-11 > div  > div").text();
      var plaintext11 =
        "\n\n-- " +
        plaintext_ext_more +
        "\t" +
        acc11_h3 +
        " --" +
        "\n\n" +
        acc11_after_h3;
    }

    if ($(".plaintext-12").hasClass("vis")) {
      var acc12_h3 = $(".plaintext-12 > div > h3 > div").text();
      $(".plaintext-12 > div > div")
        .find("a:not([href='#'])")
        .each(function () {
          // Set the innerHTML value of each Anchor element to it's own HREF
          $(this).html($(this).attr("href"));
        });
      var acc12_after_h3 = $(".plaintext-12 > div  > div").text();
      var plaintext12 = "\n\n--" + acc12_h3 + "--" + "\n\n" + acc12_after_h3;
    }

    if ($(".plaintext-13").hasClass("vis")) {
      var acc13_h3 = $(".plaintext-13 > div > h3 > div").text();
      $(".plaintext-13 > div > div")
        .find("a:not([href='#'])")
        .each(function () {
          // Set the innerHTML value of each Anchor element to it's own HREF
          $(this).html($(this).attr("href"));
        });
      var acc13_after_h3 = $(".plaintext-13 > div  > div").text();
      var plaintext13 = "\n\n--" + acc13_h3 + "--" + "\n\n" + acc13_after_h3;
    }

    var plaintext_ext = $("#ext-txt").text();
    var plaintextExt =
      plaintext_ext +
      "\n\n" +
      plaintext10 +
      "\n\n" +
      plaintext11 +
      "\n\n" +
      plaintext12 +
      "\n\n" +
      plaintext13;
    var blob = new Blob([plaintextExt], { type: "text/plain;charset=utf-8" });
    saveAs(blob, "H2A_extension_instructions.txt");

    return false;
  });

  // Restart tool - Refresh page
  $(document).on("click", "#refresh-page", function (evt) {
    $("#form")[0].scrollIntoView({ behavior: "smooth", block: "start" });
    $(" #checklist-wrap").hide();
    $("ul.stepper > li:not(:first-child)").hide();
    $("#step-1 input").each(function (ind, el) {
      el.checked = false;
      $(el).parent().find("label").css("border-color", "#cccccc");
      $("ul.stepper > li:first-child").removeClass("complete");
    });
  });

  $("#download-text-only-1, #download-text-only-2").click(function (
    event,
    today,
    calDate
  ) {
    if ($(".plaintext-01").hasClass("vis")) {
      var acc_h3 = $(".plaintext-01 > div > h3 > div").text();

      $(".plaintext-01 > div > div")
        .find("a:not([href='#'])")
        .each(function () {
          // Set the innerHTML value of each Anchor element to it's own HREF
          $(this).html($(this).attr("href"));
        });
      var acc_after_h3 = $(".plaintext-01 > div > div").text();

      plaintext01 =
        formattedDate_Plaintext +
        " " +
        chkdays +
        " days before work starts\n" +
        "\n--" +
        acc_h3 +
        "--" +
        "\n\n" +
        acc_after_h3;
    }

    if ($(".plaintext-02").hasClass("vis")) {
      var acc2_h3 = $(".plaintext-02 > div > h3 > div").text();
      $(".plaintext-02 > div > div")
        .find("a:not([href='#'])")
        .each(function () {
          // Set the innerHTML value of each Anchor element to it's own HREF
          $(this).html($(this).attr("href"));
        });
      var acc2_after_h3 = $(".plaintext-02 > div  > div").text();
      var plaintext02 =
        formattedDate_Plaintext +
        " " +
        chkdays +
        " days before work starts\n" +
        "\n--" +
        acc2_h3 +
        "--" +
        "\n\n" +
        acc2_after_h3;
    }
    if ($(".plaintext-03").hasClass("vis")) {
      var acc3_h3 = $(".plaintext-03 > div > h3 > div").text();
      $(".plaintext-03 > div > div")
        .find("a:not([href='#'])")
        .each(function () {
          // Set the innerHTML value of each Anchor element to it's own HREF
          $(this).html($(this).attr("href"));
        });
      var acc3_after_h3 = $(".plaintext-03 > div  > div").text();
      var plaintext03 =
        LaborCertFortyFiveFormatted +
        " " +
        fortyFive +
        " days before work starts\n" +
        "\n--" +
        acc3_h3 +
        "--" +
        "\n\n" +
        acc3_after_h3;
    }
    if ($(".plaintext-04").hasClass("vis")) {
      var acc4_h3 = $(".plaintext-04 > div > h3 > div").text();
      $(".plaintext-04 > div > div")
        .find("a:not([href='#'])")
        .each(function () {
          // Set the innerHTML value of each Anchor element to it's own HREF
          $(this).html($(this).attr("href"));
        });
      var acc4_after_h3 = $(".plaintext-04 > div  > div").text();
      var plaintext04 = acc4_h3 + "\n\n" + acc4_after_h3;
    }
    if ($(".plaintext-05").hasClass("vis")) {
      var acc5_h3 = $(".plaintext-05 > div > h3 > div").text();
      $(".plaintext-05 > div > div")
        .find("a:not([href='#'])")
        .each(function () {
          // Set the innerHTML value of each Anchor element to it's own HREF
          $(this).html($(this).attr("href"));
        });
      var acc5_after_h3 = $(".plaintext-05 > div  > div").text();
      var plaintext05 =
        thirtyDaysFormatted +
        " " +
        " No Later Than 30 days before work starts\n" +
        "\n--" +
        acc5_h3 +
        "--" +
        "\n\n" +
        acc5_after_h3;
    }

    if ($(".plaintext-06").hasClass("vis")) {
      var acc6_h3 = $(".plaintext-06 > div > h3 > div").text();
      $(".plaintext-06 > div > div")
        .find("a:not([href='#'])")
        .each(function () {
          // Set the innerHTML value of each Anchor element to it's own HREF
          $(this).html($(this).attr("href"));
        });
      var acc6_after_h3 = $(".plaintext-06 > div  > div").text();
      var plaintext06 = "\n\n--" + acc6_h3 + "--" + "\n\n" + acc6_after_h3;
    }
    if ($(".plaintext-07").hasClass("vis")) {
      var acc7_h3 = $(".plaintext-07 > div > h3 > div").text();
      $(".plaintext-07 > div > div")
        .find("a:not([href='#'])")
        .each(function () {
          // Set the innerHTML value of each Anchor element to it's own HREF
          $(this).html($(this).attr("href"));
        });
      var acc7_after_h3 = $(".plaintext-07 > div  > div").text();
      var plaintext07 = "\n\n--" + acc7_h3 + "--" + "\n\n" + acc7_after_h3;
    }
    if ($(".plaintext-08").hasClass("vis")) {
      var acc8_h3 = $(".plaintext-08 > div > h3 > div").text();
      $(".plaintext-08 > div > div")
        .find("a:not([href='#'])")
        .each(function () {
          // Set the innerHTML value of each Anchor element to it's own HREF
          $(this).html($(this).attr("href"));
        });
      var acc8_after_h3 = $(".plaintext-08 > div  > div").text();
      var plaintext08 = "\n\n--" + acc8_h3 + "--" + "\n\n" + acc8_after_h3;
    }
    if ($(".plaintext-09").hasClass("vis")) {
      var acc9_h3 = $(".plaintext-09 > div > h3 > div").text();
      $(".plaintext-09 > div > div")
        .find("a:not([href='#'])")
        .each(function () {
          // Set the innerHTML value of each Anchor element to it's own HREF
          $(this).html($(this).attr("href"));
        });
      var acc9_after_h3 = $(".plaintext-09 > div  > div").text();
      var plaintext09 = "\n\n--" + acc9_h3 + "--" + "\n\n" + acc9_after_h3;
    }
    if ($(".plaintext-10").hasClass("vis")) {
      var acc10_h3 = $(".plaintext-10 > div > h3 > div").text();
      $(".plaintext-10 > div > div")
        .find("a:not([href='#'])")
        .each(function () {
          // Set the innerHTML value of each Anchor element to it's own HREF
          $(this).html($(this).attr("href"));
        });
      var acc10_after_h3 = $(".plaintext-10 > div  > div").text();
      var plaintext10 = "\n\n--" + acc10_h3 + "--" + "\n\n" + acc10_after_h3;
    }

    if (diffDays >= 74.1) {
      var combined_accords =
        plaintext01 +
        "\n\n" +
        plaintext03 +
        "\n\n" +
        plaintext04 +
        "\n\n" +
        plaintext05 +
        "\n\n" +
        plaintext06 +
        "\n\n" +
        plaintext07 +
        "\n\n" +
        plaintext08 +
        "\n\n" +
        plaintext09;
      var blob = new Blob([combined_accords], {
        type: "text/plain;charset=utf-8",
      });
      saveAs(blob, "H2A_standard_checklist.txt");
    } else if (diffDays <= 74.0 && diffDays >= 45.0) {
      var combined_accords =
        plaintext02 +
        "\n\n" +
        plaintext04 +
        "\n\n" +
        plaintext05 +
        "\n\n" +
        plaintext06 +
        "\n\n" +
        plaintext07 +
        "\n\n" +
        plaintext08 +
        "\n\n" +
        plaintext09;
      var blob = new Blob([combined_accords], {
        type: "text/plain;charset=utf-8",
      });
      saveAs(blob, "H2A_emergency_checklist.txt");
    } else if ((diffDays <= 44.9 && diffDays >= 0.001) || today == calDate) {
      var acc5_h3 = $(".plaintext-05 > div > h3 > div").text();
      var acc5_after_h3 = $(".plaintext-05 > div  > div").text();
      var plaintext05imm = "--" + acc5_h3 + "--" + "\n\n" + acc5_after_h3;
      var combined_accords =
        plaintext02 +
        "\n\n" +
        plaintext04 +
        "\n\n" +
        plaintext05imm +
        "\n\n" +
        plaintext06 +
        "\n\n" +
        plaintext07 +
        "\n\n" +
        plaintext08 +
        "\n\n" +
        plaintext09;
      var blob = new Blob([combined_accords], {
        type: "text/plain;charset=utf-8",
      });
      saveAs(blob, "H2A_immediate_checklist_1.txt");
    } else if (diffDays == 0) {
      var acc10_h3 = $(".plaintext-10 > div > h3 > div").text();
      var acc10_after_h3 = $(".plaintext-10 > div  > div").text();
      var combined_accords = plaintext10;
      var blob = new Blob([combined_accords], {
        type: "text/plain;charset=utf-8",
      });
      saveAs(blob, "H2A_immediate_checklist_2.txt");
    }
  });
});

jQuery(function ($) {
  $(document).on("change", ".chb", function (event) {
    $(event.target).parent().find("label").css("border-color", "#cccccc");
    if (event.target.checked) {
      $(`label[for=${event.target.id}]`).css("border-color", "#49a564");
    }
  });
});
